import React from 'react';
import './MoreButton.scss';

// 会話ブロックが終わったときの操作。主=続きを聞く / 副=話題を変える の2つ
// banner にはボタンの下に出す広告枠（banner_bottom）を渡す
const MoreButton = ({ onMore, onChangeTopic, banner = null }) => (
  <div className="more-button-container">
    <div className="more-button-row">
      <button type="button" className="more-button" onClick={onMore}>
        続きを聞く ▸
      </button>
      <button type="button" className="more-button ghost" onClick={onChangeTopic}>
        話題を変える ▸
      </button>
    </div>
    {banner}
  </div>
);

export default MoreButton;
